export default "assets/images/black-texture-27e294b1.png";